import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withKeys as _withKeys, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "input" }
const _hoisted_3 = ["type", "disabled"]
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}

import { ref, watchEffect } from "vue";

import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-password',
  props: {
    width: { default: "100%" },
    height: { default: "2.5rem" },
    radius: { default: "0.375rem" },
    background: { default: "#fff" },
    value: {},
    disabled: { type: Boolean },
    mask: {}
  },
  emits: ["update:modelValue", "key:enter"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v32a46b89": (_ctx.width),
  "v081a0bc4": (_ctx.height),
  "v18efe72f": (_ctx.radius),
  "v68d1394b": (_ctx.background)
}))

const props = __props;

const emit = __emit;

const internalValue = ref<string | number | null>(null);

const passwordShow = ref(false);

function update(event: any) {
  let value = event.target.value;
  if (props.mask) value = props.mask(value);

  internalValue.value = value;
  emit("update:modelValue", internalValue.value);
}

watchEffect(() => {
  internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input", { disabled: __props.disabled }])
  }, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", _mergeProps({ autocomplete: "off" }, _ctx.$attrs, {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          type: passwordShow.value ? 'text' : 'password',
          disabled: __props.disabled,
          onInput: update,
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('key:enter')), ["enter"]))
        }), null, 16, _hoisted_3), [
          [_vModelDynamic, internalValue.value]
        ])
      ]),
      _renderSlot(_ctx.$slots, "sufix"),
      (!_ctx.$slots.sufix)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (passwordShow.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "pointer",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordShow.value = false))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "eye",
                    size: "1.5rem"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (passwordShow.value = true))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "eye-closed",
                    size: "1.5rem"
                  })
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})